import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HOLIDAY_TOPICS, PLOT_TOPICS } from "../lib/content";
import ArticleRenderer from "../components/ArticleRenderer";
import MiniLeadForm from "../components/MiniLeadForm";

export default function TopicPage({ kind }) {
  const { slug } = useParams();
  const list = kind === "plot" ? PLOT_TOPICS : HOLIDAY_TOPICS;
  const topic = list.find((t) => t.slug === slug);
  const basePath = kind === "plot" ? "/plots" : "/holiday-homes";
  const label = kind === "plot" ? "Plots & Land" : "Holiday Homes";

  if (!topic) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center">
        <h1 className="font-display text-4xl">Topic not found</h1>
        <Link to={basePath} className="btn-secondary mt-6 inline-flex">Back to {label}</Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16" data-testid={`topic-page-${slug}`}>
      <Link to={basePath} className="inline-flex items-center gap-2 text-sm text-zinc-600 hover:text-[#1D4ED8]">
        <ArrowLeft className="h-4 w-4" /> Back to {label}
      </Link>
      <div className="mt-8 text-xs uppercase tracking-widest text-[#1D4ED8]">{topic.kicker}</div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 leading-[1.15]">{topic.title}</h1>
      <p className="text-lg text-zinc-600 mt-6 leading-relaxed">{topic.summary}</p>

      <div className="my-10 border-t border-zinc-200" />

      <ArticleRenderer blocks={topic.body} />

      <div className="mt-14">
        <MiniLeadForm
          context={kind === "plot" ? "plot" : "holiday"}
          title={kind === "plot" ? "Want this evaluated for your specific corridor & budget?" : "Want this evaluated for your specific property goal?"}
          sub="Drop your details — we'll call you within 24 hours and walk through your situation. No commission. No pitch."
        />
      </div>

      <div className="mt-10 bg-[#EFF6FF] border border-[#1D4ED8]/20 rounded-2xl p-8">
        <div className="font-display text-2xl">Prefer a structured 45-min call?</div>
        <p className="text-zinc-700 mt-2">The Clarity Call goes deeper — review what you've been pitched, identify red flags, and map a clear next step.</p>
        <Link to="/clarity-call" className="btn-primary mt-5">Book a Clarity Call</Link>
      </div>

      <div className="mt-14">
        <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">More on {label}</div>
        <div className="grid sm:grid-cols-2 gap-4">
          {list.filter((t) => t.slug !== slug).slice(0, 4).map((t) => (
            <Link key={t.slug} to={`${basePath}/${t.slug}`} className="block border border-zinc-200 rounded-xl p-4 hover:border-[#1D4ED8]">
              <div className="font-medium text-zinc-900">{t.title}</div>
              <div className="text-xs text-zinc-500 mt-1 line-clamp-2">{t.summary}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
